import { topliApi } from '@/shared/api/topli/TopliApi'
import { useQuery } from '@tanstack/react-query'
import { SessionHistoryParams, SessionHistoryQueryParams } from '../model/types'
import { createDateRangeFilter } from '@/shared/lib/utils'

export const SessionHistoryQueryKey = 'SessionHistory'

export const fetchSessionHistory = async ({
  limit,
  offset,
  sort,
  search,
  user_id,
  dateRange = [],
}: SessionHistoryParams) => {
  const [startDate, endDate] = dateRange

  const queryParams: SessionHistoryQueryParams = {
    limit,
    offset,
    sort,
    user_id,
    ...createDateRangeFilter('user__last_login', startDate, endDate),
  }
  if (search?.length) {
    queryParams.user__fullname__icontains = search
  }

  const response = await topliApi.sessionHistory.list(queryParams)
  return response
}
export const useSessionHistory = ({
  sort,
  limit,
  offset,
  search,
  user_id,
  dateRange,
}: SessionHistoryParams) =>
  useQuery({
    queryKey: [SessionHistoryQueryKey, sort, offset, limit, search || '', user_id, dateRange],
    queryFn: () => fetchSessionHistory({ sort, limit, offset, search, user_id, dateRange }),
  })
